<template>

    <m-edit1/>

    <m-login-1 v-bind='{...{"image":"https:\/\/api.pamenarvillage.ir\/storage\/icons\/voFHj4IPLpnnzeENXr9YDNfcZPf29X5GdJIteOz5.png","showPanels":false,"imageParentClass":"col-lg-6 d-none d-lg-block","defaultPanel":null},...{}}' :style='""' class="" >
                <template #classic-login-p-1-bottom>   </template>
                
                <template #classic-login-p-1-top>   </template>
                
                <template #two-step-login-p-1-bottom>   </template>
                
                <template #two-step-login-p-1-top>   </template>
                </m-login-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mLogin1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/Login/Login1';

export default {
    name: 'HomeView',
    components: {mEdit1, mLogin1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
